<ng-container *ngFor="let order of orders">
  <!-- Desktop -->
  <div *ngIf="!isMobile" class="card p-3 mb-3">
    <div class="d-flex justify-content-between">
      <div>
        <div class="d-flex">
          <h4 class="mr-1 font-weight-bolder text-dark">{{ 'BENEFIT_TYPE_LABEL.INSURANCE' | translate }}</h4>
          <app-benefit-history-status
            [benefitHistoryType]="BenefitHistoryType.Order"
            [orderStatus]="order.orderStatus"
            [orderStatusLabel]="getOrderStatusLabel(order.orderStatus)"
          ></app-benefit-history-status>
        </div>
        <div class="text-dark">{{ order.providerName }}</div>
      </div>
    </div>

    <hr/>

    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center flex-grow-1">
        <div class="mr-1 flex-shrink-0">
          <img [src]="order.pictureUrl" alt="" class="img-fluid rounded" style="max-height: 80px; width: auto"/>
        </div>
        <div>
          <div class="text-dark small" style="margin-bottom: 2px;">
            {{ 'HISTORY.BENEFIT.NUMBER' | translate }}{{ order.itemId }}
          </div>
          <div class="text-dark small" style="margin-bottom: 2px;">{{ order.createdOn | date:'mediumDate' }}</div>
        </div>
      </div>

      <div class="align-self-end">
      <a class="btn btn-primary"
         [routerLink]="['/' + subdomain + '/benefit-details/insurance/' + order.itemId]">
          {{ 'INSURANCE.SHOW_DETAILS' | translate }}
        </a>
      </div>
    </div>
  </div>

  <!-- Mobile -->
  <div *ngIf="isMobile" class="card p-1 mb-3">
    <div class="d-flex justify-content-between">
      <div>
        <h4 class="font-weight-bolder text-dark">{{ 'BENEFIT_TYPE_LABEL.INSURANCE' | translate }}</h4>
        <div class="text-dark">{{ order.providerName }}</div>
      </div>
      <div>
        <app-benefit-history-status
          [benefitHistoryType]="BenefitHistoryType.Order"
          [orderStatus]="order.orderStatus"
          [orderStatusLabel]="getOrderStatusLabel(order.orderStatus)"
          [alignRight]="true"
        ></app-benefit-history-status>
      </div>
    </div>

    <hr/>

    <div class="d-flex justify-content-between align-items-start mb-2">
      <div style="flex-shrink: 0; max-width: 100px; max-height: 100px;">
        <img [src]="order.pictureUrl" alt="" class="img-fluid rounded"
             style="width: 100%; height: 100%; object-fit: cover;"/>
      </div>
      <div class="flex-shrink-0 ml-2">
        <a class="btn btn-primary btn-sm"
           [routerLink]="['/' + subdomain + '/benefit-details/insurance/' + order.itemId]">
          {{ 'INSURANCE.SHOW_DETAILS' | translate }}
        </a>
      </div>
    </div>

    <div class="text-dark small mb-1">
      {{ 'HISTORY.BENEFIT.NUMBER' | translate }}{{ order.itemId }}
    </div>
    <div class="text-dark small mb-1">{{ order.createdOn | date:'mediumDate' }}</div>
  </div>
</ng-container>
